export default __webpack_public_path__ + "static/common-footer-image-tablet-f5020f6f259620de2afea9b8a51821ff.png";